import { SET_PARTNERSHIP_CONFIG } from 'Actions/partnership';

export default (state = {}, action) => {
    switch (action.type) {
        case `RECEIVE_${SET_PARTNERSHIP_CONFIG}`:
            return {
                ...state,
                data: action.data
            };

        case `ERROR_${SET_PARTNERSHIP_CONFIG}`:
            return {
                ...state,
                isError: true
            };
        default:
            return state || {};
    }
};
